import AxiosService from '../AxiosService';

const NPSPost = async (npsData: any, clientCode: string) => {
    const instance = AxiosService.createAuthAxiosInstance();
    const response = await instance.post(
        '/v1/nps',
        {...npsData},
        {
            headers: {
                'client-Code': clientCode,
            },
        },
    );

    return response.data;
};

const verifyNPS = async (clientCode: string) => {
    try {
        const instance = AxiosService.createAuthAxiosInstance();
        const response = await instance.get(
            '/v1/nps/verify/' + clientCode
        );
        return response.data;
    } catch (e) {
        console.log(e)
        return false;
    }
}

export default {
    NPSPost,
    verifyNPS,
};